<template>
    <div class="sort-btn-item">
        <span @click="syncModel(true)">
        {{ label }} <i class="icon iconfont" style="vertical-align: middle" :class="{'icon-arrow-top' : curValue == 'asc', 'icon-arrow-bottom' : curValue == 'desc'}"></i>
        </span>
        <!-- <i class="icon iconfont icon-shanchu" style="vertical-align: middle" @click="deleteThisField"></i> -->
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils } from '../../app.base'
    import { Vue } from '../../app.vues'

    //
    export default {
        name: 'swb-query-sort-field',
        //
        props: {
            label: {
                type: String,
                default: null
            },
            order: {
                type: String,
                default: 'desc'
            }
        },
        //
        data() {
            return {
                curValue: null
            };
        },
        watch: {
            order(newVal, oldVal) {
                //初始化
                this.curValue = this.order.toLowerCase();
                this.syncModel();
            }
        },
        //
        created() {
            //初始化
            this.curValue = this.order.toLowerCase();
            this.syncModel();
        },
        //
        methods: {
            deleteThisField() {
                this.$emit('sortFieldDisabled');
            },
            syncModel(changeIt) {
                if(changeIt == true) {
                    this.curValue = this.curValue == 'asc' ? 'desc' : 'asc';
                }
                //
                let resultValue = this.curValue;
                //
                this.$emit('input', resultValue);
                //
                // console.log(this.label + " => " + resultValue);
                if(changeIt) {
                    this.$emit('sortFieldChanged', resultValue);
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/query/QuerySortField.vue